import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSharedModule } from '../input-shared.module';
import { InputCheckboxComponent } from './input-checkbox.component';
import { SafePipeModule } from '../../pipes/safe/safe.pipe.module';


@NgModule({
  declarations: [
    InputCheckboxComponent,
  ],
  imports: [
    CommonModule,
    InputSharedModule,
    SafePipeModule
  ],
  exports: [
    InputCheckboxComponent
  ]
})
export class InputCheckboxModule {
}
